<!-- MarkdownRenderer.vue -->
<template>
	<div v-if="content" v-html="compiledMarkdown"></div>
	<div v-else class="flex justify-center">
		<Loader />
	</div>
</template>

<script>
	import { marked } from "marked"
	import Loader from "./Loader.vue"

	export default {
		name: "MarkdownRenderer",
		props: {
			content: {
				type: String,
				required: true,
			},
		},
		components: {
			Loader,
		},
		computed: {
			compiledMarkdown() {
				return marked.parse(this.content, { breaks: true })
			},
		},
	}
</script>
